
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 197 122","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M196.302 122c-4.945-.575-10.378-1.84-16.147-3.751-10.367-3.452-19.526-11.682-28.002-25.18-7.271-11.576-13.148-25.448-18.826-38.863-10.278-24.253-19.982-47.154-34.828-48.115-14.842.955-24.548 23.858-34.812 48.11-5.678 13.416-11.562 27.288-18.826 38.863-8.476 13.497-17.63 21.732-28.001 25.179-5.77 1.916-11.206 3.181-16.149 3.751L0 115.96c4.536-.528 9.562-1.701 14.941-3.49 20.329-6.752 31.937-34.153 43.162-60.65C69.177 25.693 79.636 1.012 98.338.01L98.499 0l.163.009c18.706 1.002 29.164 25.683 40.234 51.812 11.225 26.496 22.833 53.892 43.163 60.649 5.379 1.789 10.405 2.962 14.941 3.49l-.698 6.04z","fill":"#fff"}}),_c('path',{attrs:{"d":"M99.868 6.044h-3.784V2.251h3.784v3.793zM99.868 107.316h-3.784v-7.231h3.784v7.231zm0-14.468h-3.784v-7.234h3.784v7.234zm0-14.467h-3.784v-7.234h3.784v7.234zm0-14.468h-3.784V56.68h3.784v7.234zm0-14.466h-3.784v-7.234h3.784v7.234zm0-14.468h-3.784v-7.234h3.784v7.234zm0-14.467h-3.784v-7.234h3.784v7.234zM99.868 118.351h-3.784v-3.801h3.784v3.801z","fill":"#fff"}})])
          )
        }
      }
    